import React, { useEffect, useState } from "react";
import {
  Container,
  Grid,
  Box,
  Typography,
  Button,
  Collapse,
  Divider,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import CancelIcon from "@mui/icons-material/Cancel";
import { IoIosCheckmarkCircleOutline } from "react-icons/io";
import { IoCloseCircleOutline } from "react-icons/io5";
import NewWealth from "../Globalassets/NewWealth";
import { FaChevronUp, FaChevronDown } from "react-icons/fa";
import { useLanguage } from "../../context/LanguageContext";
import axios from "axios";
import { useLangCountry } from "../../utils/getLangCountry";
import { useNavigate } from "react-router-dom";


const Account = () => {
  const [expandedIndex, setExpandedIndex] = useState(false);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const { language, translations } = useLanguage();
  const [flagUrl, setFlagUrl] = useState(""); // fallback
  const { lang } = useLangCountry();
  const navigate = useNavigate();

  const toggleExpand = (index) => {
    // setExpandedIndex((prevIndex) => (prevIndex === index ? null : index));
    setExpandedIndex((prev) => !prev);
  };

  const accountCards = [{
    id: 1,
  },


  ]

  useEffect(() => {
    const fetchCountryCode = async () => {
      try {
        const response = await axios.get("https://ipwhois.app/json/");
        const ipCountryCode = response.data.country; // e.g., 'IN'

        console.log("sdfsdfsdfsa", ipCountryCode);

        setFlagUrl(ipCountryCode);
      } catch (error) {
        console.error("Failed to fetch IP info:", error);
      }
    };

    fetchCountryCode();
  }, []);
  const accountData = [
    {
      title: translations[language]?.acountSection?.cardsTitle?.title,
      subtitle: translations[language]?.acountSection?.cardsTitle?.subtitle,
      minDeposit: translations[language]?.acountSection?.cardsTitle?.btnTitle,
      images: "https://res.cloudinary.com/dk24unkwu/image/upload/v1753695036/commision_enxz7g.png",
      type: "Standard",
      expandedDetails: {
        markets: "All markets included",
        bonus: "Yes",
        leverage: "100:1",
        spread: "From $10",
      },
    },
    {
      title: translations[language]?.acountSection?.cardsTitle?.title1,
      subtitle: translations[language]?.acountSection?.cardsTitle?.subtitle1,
      minDeposit: translations[language]?.acountSection?.cardsTitle?.btnTitle1,
      images: "https://res.cloudinary.com/dk24unkwu/image/upload/v1753695207/trades_ltdcks.png",
      type: "Trader",
      expandedDetails: {
        markets: "Forex, Precious Metals, Equity Indices, Crypto, Energies",
        bonus: "Yes",
        leverage: "70:1",
        spread: "From $5",
      },
    },
    {
      title: translations[language]?.acountSection?.cardsTitle?.title2,
      subtitle: translations[language]?.acountSection?.cardsTitle?.subtitle2,
      minDeposit: translations[language]?.acountSection?.cardsTitle?.btnTitle2,
      images: "https://res.cloudinary.com/dk24unkwu/image/upload/v1753695107/InvestLog_wpq0eu.png",
      type: "Investor",

      expandedDetails: {
        markets: "All markets, including equities",
        bonus: "Yes",
        leverage: "20:1",
        spread: "From $2",
      },
    },
  ];


  return (
    <Container maxWidth="xlg" sx={{ py: 0 }}>
      {/* Header */}
      <Box textAlign="center" mb={6} mt={17}>
        <Typography variant="subtitle1" color="rgba(25, 171, 226, 1)">
          {translations[language]?.accountType}
        </Typography>
        <Typography
          style={{ paddingTop: "15px" }}
          variant={isMobile ? "h5" : "h2"}
          fontWeight={600}
        >
          {translations[language]?.acountSection?.title}
        </Typography>
        <Box>
          <Typography
            variant="body1"
            color="text.secondary"
            style={{
              fontSize: "16px",
              fontWeight: "500",
              color: "rgba(0, 0, 0, 0.7)",
            }}
            mt={2}
            mb={3}
          >
            {translations[language]?.acountSection?.subtitle}
          </Typography>
        </Box>
        <Button
          disableRipple
          component="a"
          href="https://portal.bbcorp.trade/" // ← your actual link here
          target="_blank"
          rel="noopener noreferrer"
          variant="contained"
          size="large"
          style={{
            backgroundColor: "rgba(26, 28, 30, 1)",
            fontSize: "15px",
            boxShadow: "none",
            fontWeight: "400",
            color: "rgba(255, 255, 255, 1)",
            "&:hover": {
              backgroundColor: "rgba(25, 171, 226, 1)",
              color: "#fff",
              boxShadow: "none",
            },
            "&:active": {
              boxShadow: "none", // 🛑 no shadow on click
              boxShadow: "none",
            },
          }}
        >
          {translations[language]?.acountSection?.btnTitle}
        </Button>
      </Box>

      {/* Account Cards */}
      <Grid container spacing={4} justifyContent="center">
        {accountData?.map((account, index) => (
          <Grid
            item
            xs={12}
            sm={6}
            md={4}
            lg={4}
            key={index}
            sx={{
              display: "flex",
              justifyContent: "center",
            }}
          >
            <Box
              sx={{
                pt: 0.5,
                pl: 0.5,
                pr: 0.5,
                borderRadius: "15px",
                // boxShadow: 3,
                height: "fit-content",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                width: { xs: "100%", sm: "352px", md: "313px", lg: "350px" },
                backgroundColor: "rgba(243, 244, 245, 1)",
              }}
            >
              <Box
                sx={{
                  p: 2,
                  borderRadius: "15px",
                  // boxShadow: 3,
                  height: "100%",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",

                  backgroundColor: "#FFF",
                }}
              >
                <Box sx={{}}>
                  <Box
                    mt={0.5}
                    mb={0.1}
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                    }}
                  >
                    <img
                      src={account?.images}
                      alt="dummy"
                      style={{ width: "60px" }}
                    />
                  </Box>

                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                    }}
                  >
                    <Typography
                      variant="h4"
                      fontWeight={500}
                      color="rgba(26, 28, 30, 1)"
                    >
                      {account?.title}
                    </Typography>
                  </Box>
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                    }}
                  >
                    <Box
                      mt={1.5}
                      mb={1}
                      sx={{
                        display: "flex",
                        justifyContent: "center",
                        background: `linear-gradient(to right, rgba(36, 148, 201, 0), rgb(36 148 201 / 17%), rgba(36, 148, 201, 0))`,
                        width: "150px",
                        height: "42px",
                      }}
                    >
                      <Typography
                        variant="subtitle2"
                        color="rgba(36, 148, 201, 1)"
                        fontWeight={"500"}
                      >
                        {translations[language]?.acountSection?.cardsTitle?.sub}
                      </Typography>
                    </Box>
                  </Box>
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                    }}
                  >
                    <Typography
                      variant="body2"
                      mt={1}
                      color="text.secondary"
                      style={{ textAlign: "center" }}
                    >
                      {account.subtitle}
                    </Typography>
                  </Box>
                  <Box
                    mt={1}
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                    }}
                  >
                    {flagUrl !== "Lebanon" && (
                      <Box
                        sx={{
                          mt: 2,
                          borderRadius: 2,
                          py: 1,
                          px: 2,
                          display: "inline-block",
                          fontWeight: 600,
                          fontSize: 14,
                          color: "rgba(36, 148, 201, 1)",
                          position: "relative",
                          zIndex: 0,
                          backgroundColor: 'rgba(36, 148, 201, 0.1)'

                          // Gradient border effect
                          // "&::before": {
                          //   content: '""',
                          //   position: "absolute",
                          //   top: -1,
                          //   left: -1,
                          //   right: -1,
                          //   bottom: -1,
                          //   zIndex: -1,
                          //   borderRadius: "inherit",
                          //   padding: "1px",
                          //   background: `linear-gradient(to right, rgba(36, 148, 201, 0.6), rgba(36, 148, 201, 0.1), rgba(32, 132, 179, 0.1), rgba(36, 148, 201, 0.6))`,
                          //   WebkitMask:
                          //     "linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0)",
                          //   WebkitMaskComposite: "xor",
                          //   maskComposite: "exclude",
                          // },
                        }}
                      >
                        {account?.minDeposit}
                      </Box>
                    )}
                  </Box>
                </Box>

                <Box mt={3.5}>
                  <Button
                    disableRipple
                    variant="contained"
                    component="a"
                    href="https://portal.bbcorp.trade/auth/jwt/sign-up"
                    target="_blank"
                    rel="noopener noreferrer"
                    fullWidth
                    sx={{
                      borderRadius: 2,
                      boxShadow: "none",
                      mb: 1,
                      backgroundColor: "rgba(26, 28, 30, 1)",
                      color: "rgba(255, 255, 255, 1)",
                      "&:hover": {
                        backgroundColor: "rgba(26, 28, 30, 1)",
                        color: "#fff",
                        boxShadow: "none",
                      },
                      "&:active": {
                        boxShadow: "none", // 🛑 no shadow on click
                      },
                    }}
                  >
                    {translations[language]?.acountSection?.cardsTitle?.bltile}
                  </Button>
                </Box>
              </Box>
              {/* more */}

              {account?.type === "Standard" &&
                <Box key={index}>
                  <Collapse in={expandedIndex}>

                    <Box
                      mt={1}
                      sx={{
                        p: { xs: 2, md: 1 },

                        maxWidth: 600,
                        mx: "auto",
                      }}
                    >
                      {/* Markets Section */}
                      <Typography
                        variant="subtitle1"
                        color="text.secondary"
                        mb={0.5}
                        style={{
                          fontSize: "16px",
                          color: "rgba(102, 112, 133, 1)",
                          fontWeight: "500",
                        }}
                      >
                        {translations[language]?.acountSection?.cardsTitle?.Markets}
                      </Typography>
                      <Typography
                        variant="body2"
                        color="text.secondary"
                        mb={2}
                        style={{ fontSize: "14px", color: "rgba(0, 0, 0, 0.7)" }}
                      >
                        {translations[language]?.acountSection?.cardsTitle?.marketSub}
                      </Typography>

                      {/* Top Icons Row */}
                      <Grid container spacing={2} mb={2} justifyContent="center">
                        <Grid item xs={6}>
                          <Box
                            sx={{
                              textAlign: "center",
                              // border: "1px solid #E0E0E0",
                              borderRadius: 3,
                              py: 2,
                              width: {
                                xs: "300px",
                                sm: "146px",
                                md: "135px",
                                lg: "155px",
                              },
                              backgroundColor: "rgba(255, 255, 255, 1)",
                            }}
                          >
                            <IoIosCheckmarkCircleOutline
                              fontSize={"35px"}
                              color="rgba(36, 148, 201, 1)"
                            />
                            <Typography
                              variant="body2"
                              fontWeight={500}
                              style={{
                                fontSize: "12px",
                                paddingTop: "6px",
                                color: "rgba(102, 112, 133, 1)",
                              }}
                            >
                              {translations[language]?.acountSection?.cardsTitle?.marketT1}
                            </Typography>
                          </Box>
                        </Grid>
                        <Grid item xs={6}>
                          <Box
                            sx={{
                              textAlign: "center",
                              // border: "1px solid #E0E0E0",
                              borderRadius: 3,
                              py: 2,
                              width: {
                                xs: "300px",
                                sm: "146px",
                                md: "135px",
                                lg: "155px",
                              },

                              backgroundColor: "rgba(255, 255, 255, 1)",
                            }}
                          >
                            <IoIosCheckmarkCircleOutline
                              fontSize={"35px"}
                              color="rgba(36, 148, 201, 1)"
                            />
                            <Typography
                              variant="body2"
                              fontWeight={500}
                              style={{
                                fontSize: "12px",
                                paddingTop: "6px",
                                color: "rgba(102, 112, 133, 1)",
                              }}
                            >
                              {translations[language]?.acountSection?.cardsTitle?.marketT2}
                            </Typography>
                          </Box>
                        </Grid>
                      </Grid>

                      {/* Leverage and Stop Out */}
                      <Grid container spacing={2} mb={2} justifyContent="center">
                        <Grid item xs={6}>
                          <Box
                            sx={{
                              textAlign: "center",
                              // border: "1px solid #E0E0E0",
                              borderRadius: 3,
                              py: 2,
                              width: {
                                xs: "300px",
                                sm: "146px",
                                md: "135px",
                                lg: "155px",
                              },
                              // width: "152px",
                              backgroundColor: "rgba(255, 255, 255, 1)",
                            }}
                          >
                            <Typography
                              variant="body2"
                              fontWeight={600}
                              style={{
                                fontSize: "16px",
                                paddingTop: "6px",
                                color: "#000",
                              }}
                            >
                              {translations[language]?.acountSection?.cardsTitle?.marketT3}
                            </Typography>
                            <Typography
                              variant="body2"
                              fontWeight={500}
                              style={{
                                fontSize: "12px",
                                paddingTop: "6px",
                                color: "rgba(102, 112, 133, 1)",
                              }}
                            >
                              {translations[language]?.acountSection?.cardsTitle?.marketT4}
                            </Typography>
                          </Box>
                        </Grid>
                        <Grid item xs={6}>
                          <Box
                            sx={{
                              textAlign: "center",
                              // border: "1px solid #E0E0E0",
                              borderRadius: 3,
                              py: 2,
                              width: {
                                xs: "300px",
                                sm: "146px",
                                md: "135px",
                                lg: "155px",
                              },
                              backgroundColor: "rgba(255, 255, 255, 1)",
                            }}
                          >
                            <Typography
                              variant="body2"
                              fontWeight={600}
                              style={{
                                fontSize: "16px",
                                paddingTop: "6px",
                                color: "#000",
                              }}
                            >
                              {translations[language]?.acountSection?.cardsTitle?.marketT5}
                            </Typography>
                            <Typography
                              variant="body2"
                              fontWeight={500}
                              style={{
                                fontSize: "12px",
                                paddingTop: "6px",
                                color: "rgba(102, 112, 133, 1)",
                              }}
                            >
                              {translations[language]?.acountSection?.cardsTitle?.marketT6}
                            </Typography>
                          </Box>
                        </Grid>
                      </Grid>

                      {/* Swap Free and Commission */}
                      <Grid container spacing={2} mb={2} justifyContent="center">
                        <Grid item xs={6}>
                          <Box
                            sx={{
                              textAlign: "center",
                              // border: "1px solid #E0E0E0",
                              borderRadius: 3,
                              py: 2,
                              width: {
                                xs: "300px",
                                sm: "146px",
                                md: "135px",
                                lg: "155px",
                              },

                              backgroundColor: "rgba(255, 255, 255, 1)",
                            }}
                          >
                            <IoIosCheckmarkCircleOutline
                              fontSize={"35px"}
                              color="rgba(36, 148, 201, 1)"
                            />
                            <Typography
                              variant="body2"
                              fontWeight={500}
                              style={{
                                fontSize: "12px",
                                paddingTop: "6px",
                                color: "rgba(102, 112, 133, 1)",
                              }}
                            >
                              {translations[language]?.acountSection?.cardsTitle?.marketT7}
                            </Typography>
                          </Box>
                        </Grid>
                        <Grid item xs={6}>
                          <Box
                            sx={{
                              textAlign: "center",
                              // border: "1px solid #E0E0E0",
                              borderRadius: 3,
                              py: 2,
                              width: {
                                xs: "300px",
                                sm: "146px",
                                md: "135px",
                                lg: "155px",
                              },

                              backgroundColor: "rgba(255, 255, 255, 1)",
                            }}
                          >
                            <IoCloseCircleOutline
                              fontSize={"35px"}
                              color="rgba(255, 94, 94, 1)"
                            />
                            <Typography
                              variant="body2"
                              fontWeight={500}
                              style={{
                                fontSize: "12px",
                                paddingTop: "6px",
                                color: "rgba(102, 112, 133, 1)",
                              }}
                            >
                              {translations[language]?.acountSection?.cardsTitle?.marketT8}
                            </Typography>
                          </Box>
                        </Grid>
                      </Grid>

                      {/* Minimum Deposit */}
                      {flagUrl !== "Lebanon" && (
                        <Box
                          sx={{
                            textAlign: "center",
                            background: "#FFF",
                            borderRadius: "15px",
                            py: 1.5,
                            mb: 2,
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            px: 2,
                          }}
                        >
                          <Typography
                            variant="body2"
                            color="rgba(102, 112, 133, 1)"
                          >
                            {translations[language]?.acountSection?.cardsTitle?.marketT9}
                          </Typography>
                          <Typography variant="h6" fontWeight={700}>
                            {translations[language]?.acountSection?.cardsTitle?.marketT10}
                          </Typography>
                        </Box>
                      )}

                      {/* Spread Section */}
                      <Box
                        py={1.5}
                        px={2}
                        sx={{
                          mb: 1,
                          backgroundColor: "#fff",
                          borderRadius: "15px",
                        }}
                      >
                        <Typography
                          variant="body2"
                          color="rgba(102, 112, 133, 1)"
                        >
                          {translations[language]?.acountSection?.cardsTitle?.marketT11}
                        </Typography>
                        <Grid container spacing={2} mt={1}>
                          <Grid item xs={4}>
                            <Box
                              p={0.7}
                              textAlign="center"
                              sx={{
                                backgroundColor: "rgba(243, 244, 245, 1)",
                                width: { xs: "127px", md: "120px", lg: "87px" },
                                borderRadius: "15px",
                              }}
                            >
                              <Typography
                                fontWeight={600}
                                style={{
                                  fontSize: "14px",
                                  color: "rgba(26, 28, 30, 1)",
                                }}
                              >
                                2.7
                              </Typography>
                              <Typography
                                variant="caption"
                                color="text.secondary"
                              >
                                GOLD
                              </Typography>
                            </Box>
                          </Grid>
                          <Grid item xs={4}>
                            <Box
                              p={0.7}
                              textAlign="center"
                              sx={{
                                backgroundColor: "rgba(243, 244, 245, 1)",
                                width: { xs: "127px", md: "120px", lg: "87px" },
                                borderRadius: "15px",
                              }}
                            >
                              <Typography
                                fontWeight={600}
                                style={{
                                  fontSize: "14px",
                                  color: "rgba(26, 28, 30, 1)",
                                }}
                              >
                                2
                              </Typography>
                              <Typography
                                variant="caption"
                                color="text.secondary"
                              >
                                USD/JPY
                              </Typography>
                            </Box>
                          </Grid>
                          <Grid item xs={4}>
                            <Box
                              p={0.7}
                              textAlign="center"
                              sx={{
                                backgroundColor: "rgba(243, 244, 245, 1)",
                                width: { xs: "127px", md: "120px", lg: "87px" },
                                borderRadius: "15px",
                              }}
                            >
                              <Typography
                                fontWeight={600}
                                style={{
                                  fontSize: "14px",
                                  color: "rgba(26, 28, 30, 1)",
                                }}
                              >
                                1.6
                              </Typography>
                              <Typography
                                variant="caption"
                                color="text.secondary"
                              >
                                USD/JPY
                              </Typography>
                            </Box>
                          </Grid>
                        </Grid>
                      </Box>

                      <Typography variant="caption" color="text.secondary">
                        {translations[language]?.acountSection?.cardsTitle?.tier}
                      </Typography>
                    </Box>
                  </Collapse>

                  <Button
                    variant="text"
                    disableRipple
                    fullWidth
                    onClick={() => toggleExpand(index)}
                    style={{
                      color: "rgba(102, 112, 133, 1)",
                      backgroundColor:
                        expandedIndex === index
                          ? "rgba(229, 231, 234, 0.75)"
                          : "transparent",
                      fontWeight: "500",
                      marginBottom: "5px",
                      borderRadius: "15px",
                    }}
                  >
                    {expandedIndex ? (
                      <>
                        {translations[language]?.acountSection?.cardsTitle.less}{" "}
                        <FaChevronUp FaChevronDown style={{ marginLeft: 5 }} />
                      </>
                    ) : (
                      <>
                        {translations[language]?.acountSection?.cardsTitle?.show} <FaChevronDown style={{ marginLeft: 5 }} />
                      </>
                    )}
                  </Button>
                </Box>
              }
              {account?.type === "Trader" &&
                <Box key={index}>
                  <Collapse in={expandedIndex}>

                    <Box
                      mt={1}
                      sx={{
                        p: { xs: 2, md: 1 },

                        maxWidth: 600,
                        mx: "auto",
                      }}
                    >
                      {/* Markets Section */}
                      <Typography
                        variant="subtitle1"
                        color="text.secondary"
                        mb={0.5}
                        style={{
                          fontSize: "16px",
                          color: "rgba(102, 112, 133, 1)",
                          fontWeight: "500",
                        }}
                      >
                        {translations[language]?.acountSection?.cardsTitle?.Markets}
                      </Typography>
                      <Typography
                        variant="body2"
                        color="text.secondary"
                        mb={2}
                        style={{ fontSize: "14px", color: "rgba(0, 0, 0, 0.7)" }}
                      >
                        {translations[language]?.acountSection?.cardsTitle?.marketSub}
                      </Typography>

                      {/* Top Icons Row */}
                      <Grid container spacing={2} mb={2} justifyContent="center">
                        <Grid item xs={6}>
                          <Box
                            sx={{
                              textAlign: "center",
                              // border: "1px solid #E0E0E0",
                              borderRadius: 3,
                              py: 2,
                              width: {
                                xs: "300px",
                                sm: "146px",
                                md: "135px",
                                lg: "155px",
                              },
                              backgroundColor: "rgba(255, 255, 255, 1)",
                            }}
                          >
                            <IoIosCheckmarkCircleOutline
                              fontSize={"35px"}
                              color="rgba(36, 148, 201, 1)"
                            />
                            <Typography
                              variant="body2"
                              fontWeight={500}
                              style={{
                                fontSize: "12px",
                                paddingTop: "6px",
                                color: "rgba(102, 112, 133, 1)",
                              }}
                            >
                              {translations[language]?.acountSection?.cardsTitle?.marketT1}
                            </Typography>
                          </Box>
                        </Grid>
                        <Grid item xs={6}>
                          <Box
                            sx={{
                              textAlign: "center",
                              // border: "1px solid #E0E0E0",
                              borderRadius: 3,
                              py: 2,
                              width: {
                                xs: "300px",
                                sm: "146px",
                                md: "135px",
                                lg: "155px",
                              },

                              backgroundColor: "rgba(255, 255, 255, 1)",
                            }}
                          >
                            <IoIosCheckmarkCircleOutline
                              fontSize={"35px"}
                              color="rgba(36, 148, 201, 1)"
                            />
                            <Typography
                              variant="body2"
                              fontWeight={500}
                              style={{
                                fontSize: "12px",
                                paddingTop: "6px",
                                color: "rgba(102, 112, 133, 1)",
                              }}
                            >
                              {translations[language]?.acountSection?.cardsTitle?.marketT2}
                            </Typography>
                          </Box>
                        </Grid>
                      </Grid>

                      {/* Leverage and Stop Out */}
                      <Grid container spacing={2} mb={2} justifyContent="center">
                        <Grid item xs={6}>
                          <Box
                            sx={{
                              textAlign: "center",
                              // border: "1px solid #E0E0E0",
                              borderRadius: 3,
                              py: 2,
                              width: {
                                xs: "300px",
                                sm: "146px",
                                md: "135px",
                                lg: "155px",
                              },
                              // width: "152px",
                              backgroundColor: "rgba(255, 255, 255, 1)",
                            }}
                          >
                            <Typography
                              variant="body2"
                              fontWeight={600}
                              style={{
                                fontSize: "16px",
                                paddingTop: "6px",
                                color: "#000",
                              }}
                            >
                              {translations[language]?.acountSection?.cardsTitle?.marketT3}
                            </Typography>
                            <Typography
                              variant="body2"
                              fontWeight={500}
                              style={{
                                fontSize: "12px",
                                paddingTop: "6px",
                                color: "rgba(102, 112, 133, 1)",
                              }}
                            >
                              {translations[language]?.acountSection?.cardsTitle?.marketT4}
                            </Typography>
                          </Box>
                        </Grid>
                        <Grid item xs={6}>
                          <Box
                            sx={{
                              textAlign: "center",
                              // border: "1px solid #E0E0E0",
                              borderRadius: 3,
                              py: 2,
                              width: {
                                xs: "300px",
                                sm: "146px",
                                md: "135px",
                                lg: "155px",
                              },
                              backgroundColor: "rgba(255, 255, 255, 1)",
                            }}
                          >
                            <Typography
                              variant="body2"
                              fontWeight={600}
                              style={{
                                fontSize: "16px",
                                paddingTop: "6px",
                                color: "#000",
                              }}
                            >
                              {translations[language]?.acountSection?.cardsTitle?.marketT5}
                            </Typography>
                            <Typography
                              variant="body2"
                              fontWeight={500}
                              style={{
                                fontSize: "12px",
                                paddingTop: "6px",
                                color: "rgba(102, 112, 133, 1)",
                              }}
                            >
                              {translations[language]?.acountSection?.cardsTitle?.marketT6}
                            </Typography>
                          </Box>
                        </Grid>
                      </Grid>

                      {/* Swap Free and Commission */}
                      <Grid container spacing={2} mb={2} justifyContent="center">
                        <Grid item xs={6}>
                          <Box
                            sx={{
                              textAlign: "center",
                              // border: "1px solid #E0E0E0",
                              borderRadius: 3,
                              py: 2,
                              width: {
                                xs: "300px",
                                sm: "146px",
                                md: "135px",
                                lg: "155px",
                              },

                              backgroundColor: "rgba(255, 255, 255, 1)",
                            }}
                          >
                            <IoIosCheckmarkCircleOutline
                              fontSize={"35px"}
                              color="rgba(36, 148, 201, 1)"
                            />
                            <Typography
                              variant="body2"
                              fontWeight={500}
                              style={{
                                fontSize: "12px",
                                paddingTop: "6px",
                                color: "rgba(102, 112, 133, 1)",
                              }}
                            >
                              {translations[language]?.acountSection?.cardsTitle?.marketT7}
                            </Typography>
                          </Box>
                        </Grid>
                        <Grid item xs={6}>
                          <Box
                            sx={{
                              textAlign: "center",
                              // border: "1px solid #E0E0E0",
                              borderRadius: 3,
                              py: 2,
                              width: {
                                xs: "300px",
                                sm: "146px",
                                md: "135px",
                                lg: "155px",
                              },

                              backgroundColor: "rgba(255, 255, 255, 1)",
                            }}
                          >
                            <Typography
                              variant="body2"
                              fontWeight={600}
                              style={{
                                fontSize: "16px",
                                paddingTop: "6px",
                                color: "#000",
                              }}
                            >
                              Low
                            </Typography>
                            <Typography
                              variant="body2"
                              fontWeight={500}
                              style={{
                                fontSize: "12px",
                                paddingTop: "6px",
                                color: "rgba(102, 112, 133, 1)",
                              }}
                            >
                              {translations[language]?.acountSection?.cardsTitle?.marketT8}
                            </Typography>
                          </Box>
                        </Grid>
                      </Grid>

                      {/* Minimum Deposit */}
                      {flagUrl !== "Lebanon" && (
                        <Box
                          sx={{
                            textAlign: "center",
                            background: "#FFF",
                            borderRadius: "15px",
                            py: 1.5,
                            mb: 2,
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            px: 2,
                          }}
                        >
                          <Typography
                            variant="body2"
                            color="rgba(102, 112, 133, 1)"
                          >
                            {translations[language]?.acountSection?.cardsTitle?.marketT9}
                          </Typography>
                          <Typography variant="h6" fontWeight={700}>
                            {translations[language]?.acountSection?.cardsTitle?.marketT10}
                          </Typography>
                        </Box>
                      )}

                      {/* Spread Section */}
                      <Box
                        py={1.5}
                        px={2}
                        sx={{
                          mb: 1,
                          backgroundColor: "#fff",
                          borderRadius: "15px",
                        }}
                      >
                        <Typography
                          variant="body2"
                          color="rgba(102, 112, 133, 1)"
                        >
                          {translations[language]?.acountSection?.cardsTitle?.marketT11}
                        </Typography>
                        <Grid container spacing={2} mt={1}>
                          <Grid item xs={4}>
                            <Box
                              p={0.7}
                              textAlign="center"
                              sx={{
                                backgroundColor: "rgba(243, 244, 245, 1)",
                                width: { xs: "127px", md: "120px", lg: "87px" },
                                borderRadius: "15px",
                              }}
                            >
                              <Typography
                                fontWeight={600}
                                style={{
                                  fontSize: "14px",
                                  color: "rgba(26, 28, 30, 1)",
                                }}
                              >
                                1.6
                              </Typography>
                              <Typography
                                variant="caption"
                                color="text.secondary"
                              >
                                GOLD
                              </Typography>
                            </Box>
                          </Grid>
                          <Grid item xs={4}>
                            <Box
                              p={0.7}
                              textAlign="center"
                              sx={{
                                backgroundColor: "rgba(243, 244, 245, 1)",
                                width: { xs: "127px", md: "120px", lg: "87px" },
                                borderRadius: "15px",
                              }}
                            >
                              <Typography
                                fontWeight={600}
                                style={{
                                  fontSize: "14px",
                                  color: "rgba(26, 28, 30, 1)",
                                }}
                              >
                                0.2
                              </Typography>
                              <Typography
                                variant="caption"
                                color="text.secondary"
                              >
                                USD/JPY
                              </Typography>
                            </Box>
                          </Grid>
                          <Grid item xs={4}>
                            <Box
                              p={0.7}
                              textAlign="center"
                              sx={{
                                backgroundColor: "rgba(243, 244, 245, 1)",
                                width: { xs: "127px", md: "120px", lg: "87px" },
                                borderRadius: "15px",
                              }}
                            >
                              <Typography
                                fontWeight={600}
                                style={{
                                  fontSize: "14px",
                                  color: "rgba(26, 28, 30, 1)",
                                }}
                              >
                                0.8
                              </Typography>
                              <Typography
                                variant="caption"
                                color="text.secondary"
                              >
                                USD/JPY
                              </Typography>
                            </Box>
                          </Grid>
                        </Grid>
                      </Box>

                      <Typography variant="caption" color="text.secondary">
                        {translations[language]?.acountSection?.cardsTitle?.tier}
                      </Typography>
                    </Box>
                  </Collapse>

                  <Button
                    variant="text"
                    disableRipple
                    fullWidth
                    onClick={() => toggleExpand(index)}
                    style={{
                      color: "rgba(102, 112, 133, 1)",
                      backgroundColor:
                        expandedIndex === index
                          ? "rgba(229, 231, 234, 0.75)"
                          : "transparent",
                      fontWeight: "500",
                      marginBottom: "5px",
                      borderRadius: "15px",
                    }}
                  >
                    {expandedIndex ? (
                      <>
                        {translations[language]?.acountSection?.cardsTitle.less}{" "}
                        <FaChevronUp FaChevronDown style={{ marginLeft: 5 }} />
                      </>
                    ) : (
                      <>
                        {translations[language]?.acountSection?.cardsTitle?.show} <FaChevronDown style={{ marginLeft: 5 }} />
                      </>
                    )}
                  </Button>
                </Box>
              }
              {account?.type === "Investor" &&
                <Box key={index}>
                  <Collapse in={expandedIndex}>

                    <Box
                      mt={1}
                      sx={{
                        p: { xs: 2, md: 1 },

                        maxWidth: 600,
                        mx: "auto",
                      }}
                    >
                      {/* Markets Section */}
                      <Typography
                        variant="subtitle1"
                        color="text.secondary"
                        mb={0.5}
                        style={{
                          fontSize: "16px",
                          color: "rgba(102, 112, 133, 1)",
                          fontWeight: "500",
                        }}
                      >
                        {translations[language]?.acountSection?.cardsTitle?.Markets}
                      </Typography>
                      <Typography
                        variant="body2"
                        color="text.secondary"
                        mb={2}
                        // mt={5}
                        style={{ fontSize: "14px", color: "rgba(0, 0, 0, 0.7)" }}
                      >
                        {translations[language]?.acountSection?.cardsTitle?.marketSub}
                      </Typography>

                      {/* Top Icons Row */}
                      <Grid container spacing={2} mb={2} justifyContent="center">
                        <Grid item xs={6}>
                          <Box
                            sx={{
                              textAlign: "center",
                              // border: "1px solid #E0E0E0",
                              borderRadius: 3,
                              py: 2,
                              width: {
                                xs: "300px",
                                sm: "146px",
                                md: "135px",
                                lg: "155px",
                              },

                              backgroundColor: "rgba(255, 255, 255, 1)",
                            }}
                          >
                            <IoCloseCircleOutline
                              fontSize={"35px"}
                              color="rgba(255, 94, 94, 1)"
                            />
                            <Typography
                              variant="body2"
                              fontWeight={500}
                              style={{
                                fontSize: "12px",
                                paddingTop: "6px",
                                color: "rgba(102, 112, 133, 1)",
                              }}
                            >
                              Bonus Eligibility*
                            </Typography>
                          </Box>
                        </Grid>
                        <Grid item xs={6}>
                          <Box
                            sx={{
                              textAlign: "center",
                              // border: "1px solid #E0E0E0",
                              borderRadius: 3,
                              py: 2,
                              width: {
                                xs: "300px",
                                sm: "146px",
                                md: "135px",
                                lg: "155px",
                              },

                              backgroundColor: "rgba(255, 255, 255, 1)",
                            }}
                          >
                            <IoIosCheckmarkCircleOutline
                              fontSize={"35px"}
                              color="rgba(36, 148, 201, 1)"
                            />
                            <Typography
                              variant="body2"
                              fontWeight={500}
                              style={{
                                fontSize: "12px",
                                paddingTop: "6px",
                                color: "rgba(102, 112, 133, 1)",
                              }}
                            >
                              Micro Account Options
                            </Typography>
                          </Box>
                        </Grid>
                      </Grid>

                      {/* Leverage and Stop Out */}
                      <Grid container spacing={2} mb={2} justifyContent="center">
                        <Grid item xs={6}>
                          <Box
                            sx={{
                              textAlign: "center",
                              // border: "1px solid #E0E0E0",
                              borderRadius: 3,
                              py: 2,
                              width: {
                                xs: "300px",
                                sm: "146px",
                                md: "135px",
                                lg: "155px",
                              },
                              // width: "152px",
                              backgroundColor: "rgba(255, 255, 255, 1)",
                            }}
                          >
                            <Typography
                              variant="body2"
                              fontWeight={600}
                              style={{
                                fontSize: "16px",
                                paddingTop: "6px",
                                color: "#000",
                              }}
                            >
                              Custom
                            </Typography>
                            <Typography
                              variant="body2"
                              fontWeight={500}
                              style={{
                                fontSize: "12px",
                                paddingTop: "6px",
                                color: "rgba(102, 112, 133, 1)",
                              }}
                            >
                              {translations[language]?.acountSection?.cardsTitle?.marketT4}
                            </Typography>
                          </Box>
                        </Grid>
                        <Grid item xs={6}>
                          <Box
                            sx={{
                              textAlign: "center",
                              // border: "1px solid #E0E0E0",
                              borderRadius: 3,
                              py: 2,
                              width: {
                                xs: "300px",
                                sm: "146px",
                                md: "135px",
                                lg: "155px",
                              },
                              backgroundColor: "rgba(255, 255, 255, 1)",
                            }}
                          >
                            <Typography
                              variant="body2"
                              fontWeight={600}
                              style={{
                                fontSize: "16px",
                                paddingTop: "6px",
                                color: "#000",
                              }}
                            >
                              Custom
                            </Typography>
                            <Typography
                              variant="body2"
                              fontWeight={500}
                              style={{
                                fontSize: "12px",
                                paddingTop: "6px",
                                color: "rgba(102, 112, 133, 1)",
                              }}
                            >
                              {translations[language]?.acountSection?.cardsTitle?.marketT6}
                            </Typography>
                          </Box>
                        </Grid>
                      </Grid>

                      {/* Swap Free and Commission */}
                      <Grid container spacing={2} mb={2} justifyContent="center">
                        <Grid item xs={6}>
                          <Box
                            sx={{
                              textAlign: "center",
                              // border: "1px solid #E0E0E0",
                              borderRadius: 3,
                              py: 2,
                              width: {
                                xs: "300px",
                                sm: "146px",
                                md: "135px",
                                lg: "155px",
                              },

                              backgroundColor: "rgba(255, 255, 255, 1)",
                            }}
                          >
                            <IoIosCheckmarkCircleOutline
                              fontSize={"35px"}
                              color="rgba(36, 148, 201, 1)"
                            />
                            <Typography
                              variant="body2"
                              fontWeight={500}
                              style={{
                                fontSize: "12px",
                                paddingTop: "6px",
                                color: "rgba(102, 112, 133, 1)",
                              }}
                            >
                              Swap Free
                            </Typography>
                          </Box>
                        </Grid>
                        <Grid item xs={6}>
                          <Box
                            sx={{
                              textAlign: "center",
                              // border: "1px solid #E0E0E0",
                              borderRadius: 3,
                              py: 2,
                              width: {
                                xs: "300px",
                                sm: "146px",
                                md: "135px",
                                lg: "155px",
                              },

                              backgroundColor: "rgba(255, 255, 255, 1)",
                            }}
                          >
                            <IoCloseCircleOutline
                              fontSize={"35px"}
                              color="rgba(255, 94, 94, 1)"
                            />
                            <Typography
                              variant="body2"
                              fontWeight={500}
                              style={{
                                fontSize: "12px",
                                paddingTop: "6px",
                                color: "rgba(102, 112, 133, 1)",
                              }}
                            >
                              Commission
                            </Typography>
                          </Box>
                        </Grid>
                      </Grid>

                      {/* Minimum Deposit */}
                      {flagUrl !== "Lebanon" && (
                        <Box
                          sx={{
                            textAlign: "center",
                            background: "#FFF",
                            borderRadius: "15px",
                            py: 1.5,
                            mb: 2,
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            px: 2,
                          }}
                        >
                          <Typography
                            variant="body2"
                            color="rgba(102, 112, 133, 1)"
                          >
                            {translations[language]?.acountSection?.cardsTitle?.marketT9}
                          </Typography>
                          <Typography variant="h6" fontWeight={700}>
                            $30,000

                          </Typography>
                        </Box>
                      )}

                      {/* Spread Section */}
                      <Box
                        py={1.5}
                        px={2}
                        sx={{
                          mb: 1,
                          backgroundColor: "#fff",
                          borderRadius: "15px",
                        }}
                      >
                        <Typography
                          variant="body2"
                          color="rgba(102, 112, 133, 1)"
                        >
                          {translations[language]?.acountSection?.cardsTitle?.marketT11}
                        </Typography>
                        <Grid container spacing={2} mt={1}>
                          <Grid item xs={4}>
                            <Box
                              p={0.7}
                              textAlign="center"
                              sx={{
                                backgroundColor: "rgba(243, 244, 245, 1)",
                                width: { xs: "127px", md: "120px", lg: "87px" },
                                borderRadius: "15px",
                              }}
                            >
                              <Typography
                                fontWeight={600}
                                style={{
                                  fontSize: "14px",
                                  color: "rgba(26, 28, 30, 1)",
                                }}
                              >
                                2.7
                              </Typography>
                              <Typography
                                variant="caption"
                                color="text.secondary"
                              >
                                GOLD
                              </Typography>
                            </Box>
                          </Grid>
                          <Grid item xs={4}>
                            <Box
                              p={0.7}
                              textAlign="center"
                              sx={{
                                backgroundColor: "rgba(243, 244, 245, 1)",
                                width: { xs: "127px", md: "120px", lg: "87px" },
                                borderRadius: "15px",
                              }}
                            >
                              <Typography
                                fontWeight={600}
                                style={{
                                  fontSize: "14px",
                                  color: "rgba(26, 28, 30, 1)",
                                }}
                              >
                                2
                              </Typography>
                              <Typography
                                variant="caption"
                                color="text.secondary"
                              >
                                USD/JPY
                              </Typography>
                            </Box>
                          </Grid>
                          <Grid item xs={4}>
                            <Box
                              p={0.7}
                              textAlign="center"
                              sx={{
                                backgroundColor: "rgba(243, 244, 245, 1)",
                                width: { xs: "127px", md: "120px", lg: "87px" },
                                borderRadius: "15px",
                              }}
                            >
                              <Typography
                                fontWeight={600}
                                style={{
                                  fontSize: "14px",
                                  color: "rgba(26, 28, 30, 1)",
                                }}
                              >
                                1.6
                              </Typography>
                              <Typography
                                variant="caption"
                                color="text.secondary"
                              >
                                USD/JPY
                              </Typography>
                            </Box>
                          </Grid>
                        </Grid>
                      </Box>

                      <Typography variant="caption" color="text.secondary">
                        {translations[language]?.acountSection?.cardsTitle?.tier}
                      </Typography>
                    </Box>
                  </Collapse>

                  <Button
                    variant="text"
                    disableRipple
                    fullWidth
                    onClick={() => toggleExpand(index)}
                    style={{
                      color: "rgba(102, 112, 133, 1)",
                      backgroundColor:
                        expandedIndex === index
                          ? "rgba(229, 231, 234, 0.75)"
                          : "transparent",
                      fontWeight: "500",
                      marginBottom: "5px",
                      borderRadius: "15px",
                    }}
                  >
                    {expandedIndex ? (
                      <>
                        {translations[language]?.acountSection?.cardsTitle.less}{" "}
                        <FaChevronUp FaChevronDown style={{ marginLeft: 5 }} />
                      </>
                    ) : (
                      <>
                        {translations[language]?.acountSection?.cardsTitle?.show} <FaChevronDown style={{ marginLeft: 5 }} />
                      </>
                    )}
                  </Button>
                </Box>
              }
            </Box>
          </Grid>
        ))}
      </Grid>

      {/* Footer Note */}
      <Typography
        variant="caption"
        color="text.secondary"
        mt={5}
        display="block"
        textAlign="center"
        style={{ fontSize: "15px" }}
      >
        {translations[language]?.acountSection?.cardsTitle?.firsy} <br /> {translations[language]?.acountSection?.cardsTitle?.firsy1}
      </Typography>
      <Box mt={12}>
        <NewWealth />
      </Box>
    </Container>
  );
};

export default Account;
